// src/tattoo/GuideToolbar.jsx (or wherever this lives)
import React from "react";
import { guidePaintRef } from "./GuidePaint";
import { addLayerFromCanvas, tattoo } from "./state";

// import { addLayerFromCanvas, tattoo } from "./state";  ← no longer needed for add
import { addPaintLayerFromGP } from "./paintToLayer";
import { isSharedView } from "./sharedCommentsApi";

function hexToRgba(hex, alpha = 0.75) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "#ff0000");
  const r = parseInt(m?.[1] || "ff", 16);
  const g = parseInt(m?.[2] || "00", 16);
  const b = parseInt(m?.[3] || "00", 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

// utils/stampName.js (or inline here)
export function stampName(prefix = "Paint", tz = "America/Toronto") {
  const d = new Date();
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const parts = fmt.format(d).replace(",", "");
  return `${prefix} ${parts}`;
}

export default function GuideToolbar() {
  const [color, setColor] = React.useState("#ff0000");
  const [alpha, setAlpha] = React.useState(1);
  const [brush, setBrush] = React.useState(8);
  const [canAdd, setCanAdd] = React.useState(false);

  // reflect strokes / enable “Add as layer”
  React.useEffect(() => {
    const update = () => {
      const gp = guidePaintRef.current;
      setCanAdd(!!gp && !gp.isEmpty?.());
    };
    update();
    window.addEventListener("guidepaint:stroke", update);
    window.addEventListener("guidepaint:toggle", update);
    return () => {
      window.removeEventListener("guidepaint:stroke", update);
      window.removeEventListener("guidepaint:toggle", update);
    };
  }, []);

  // always push current UI values into the painter
  React.useEffect(() => {
    const gp = guidePaintRef.current;
    if (!gp) return;

    if (typeof gp.setAlpha !== "function") {
      gp.setAlpha = (a) => {
        gp.alpha = Math.max(0, Math.min(1, +a || 0));
      };
    }
    if (typeof gp.setBrush !== "function" && typeof gp.setSize === "function") {
      gp.setBrush = gp.setSize.bind(gp);
    }

    gp.setColor?.(hexToRgba(color, alpha));
    gp.setBrush?.(brush);
  }, [color, alpha, brush]);

  const clear = () => guidePaintRef.current?.clear?.();

  const viewMode = isSharedView(); // true on /view links

  const addAsLayer = async () => {
    if (viewMode) {
      // In shared /view: treat this as "Attach sketch" into comments
      window.dispatchEvent(new Event("comments:attach-from-model"));
      return;
    }
    // In /app: keep existing layer behavior
    await addPaintLayerFromGP();
  };

  return (
    <div className="section">
      <div
        className="row"
        style={{
          gap: 8,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {!canAdd && (
          <span className="tt-muted" style={{ fontSize: 12 }}>
            Hold <strong>D</strong> to paint, <strong>E</strong> to erase.
          </span>
        )}

        {/* ✅ Single, real color input — works on desktop + iOS */}

        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          aria-label="Brush color"
          title="Brush color"
          className="gp-color-input"
        />

        {/* (optional) keep brush + alpha if you had sliders elsewhere */}

        {canAdd && (
          <>
            <button className="ghost" onClick={clear}>
              Clear
            </button>
            <button className="ghost" onClick={addAsLayer}>
              {isSharedView() ? "Attach sketch" : "Add as layer"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
